import { GetAllCoaches } from './../types/coaches'
import { AnyAction } from 'redux'
import userReducer from './reducers/user/reducers'
import chatReducer from './reducers/chat/reducers'
import scheduleReducer from './reducers/schedule/reducers'
import patientOverviewReducer from './reducers/patientOverview/reducers'
import clinicManagementReducer from './reducers/clinicManagement/reducers'
import { AppState, ROOT_REDUCER_ACTION_TYPES } from '../types/rootStoreTypes'
import searchPatientsReducer from './reducers/patients/reducers'
import searchCoachesReducer from './reducers/coaches/reducers'
import bulkActionReducer from './reducers/bulk/reducers'
import alertsReducer from './reducers/alerts/reducers'
import realtimeAlertsReducer from './reducers/realtimeAlerts/reducers'
import myPatientsReducer from './reducers/myPatients/reducers'
import recentlyViewedReducer from './reducers/recentlyViewed/reducers'
import { UserAction } from '../types/user'
import { SearchPatientAction } from '../types/patients'
import { BulkActionOnAction } from '../types/bulk'
import { AlertsAction } from '../types/alert'
import { RealtimeAlertsAction } from '../types/realtimeAlerts'
import orgSettingsReducer from './reducers/orgSettings/reducers'
import { ChatActions } from '../types/chat'
import { MyPatientsAction } from './reducers/myPatients/types'
import { RecentlyViewedAction } from './reducers/recentlyViewed/types'

export const appReducer = (
	state: AppState | Partial<AppState> = {},
	action: AnyAction
): AppState | Partial<AppState> => {
	if (action.type === ROOT_REDUCER_ACTION_TYPES.ROOT_REDUCER_RESET) {
		return {}
	}

	return {
		user: userReducer(state.user, action as UserAction),
		schedule: scheduleReducer(state.schedule, action),
		patientOverview: patientOverviewReducer(state.patientOverview, action),
		searchPatients: searchPatientsReducer(
			state.searchPatients,
			action as SearchPatientAction
		),
		searchCoaches: searchCoachesReducer(
			state.searchCoaches,
			action as GetAllCoaches
		),
		bulk: bulkActionReducer(state.bulk, action as BulkActionOnAction),
		clinicManagement: clinicManagementReducer(
			state.clinicManagement,
			action
		),
		alerts: alertsReducer(state.alerts, action as AlertsAction),
		realtimeAlerts: realtimeAlertsReducer(
			state.realtimeAlerts,
			action as RealtimeAlertsAction
		),
		orgSettings: orgSettingsReducer(state.orgSettings, action),
		chat: chatReducer(state.chat, action as ChatActions),
		myPatients: myPatientsReducer(
			state.myPatients,
			action as MyPatientsAction
		),
		recentlyViewed: recentlyViewedReducer(
			state.recentlyViewed,
			action as RecentlyViewedAction
		),
	}
}
